import { render, staticRenderFns } from "./RelatorioCompras.vue?vue&type=template&id=323c6dc3&"
import script from "./RelatorioCompras.vue?vue&type=script&lang=js&"
export * from "./RelatorioCompras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports